import { useMemo } from 'react';
import { matchPath, useLocation, useRouteMatch } from 'react-router-dom';
import descriptions from './descriptions.json';
import { AppTester, AppTesterType } from 'supporting';
import { useTranslation } from 'react-i18next';
import { LinkTo } from 'shared/constants/linkTo';

interface TitleDescription {
  title: string;
  description: string;
}

const EMPTY_META: TitleDescription = { title: '', description: '' };

export const getMetaDescription = ({ AppTester, pathname, lang = 'ru' }: { AppTester: AppTesterType, pathname: string, lang?: string }) => {
  const isAwardsPage = !!matchPath(pathname, { path: '/awards', exact: true });
  const isLab = !!matchPath(pathname, { path: '/laboratories', exact: true });
  const isPromptWeekend = !!matchPath(pathname, { path: '/prompt-weekend', exact: true });
  const isPromptBrand = !!matchPath(pathname, { path: '/prompt-brand', exact: false });
  const isPromptVideo = !!matchPath(pathname, { path: '/prompt-video', exact: false });
  const isPromptCode = !!matchPath(pathname, { path: '/prompt-code', exact: false });

  const isAKI = AppTester.isAKI()
  const isTagsPage = !!matchPath(pathname, { path: '/tags', exact: true });
  const isThemesPage = !!matchPath(pathname, { path: '/competencies', exact: true });
  const isEduPage = !!matchPath(pathname, { path: '/education', exact: true });
  const isAbout = !!matchPath(pathname, { path: '/about', exact: true });
  const isSupport = !!matchPath(pathname, { path: '/support', exact: true });
  const isMediiiaResidentsPage = 
    !!matchPath(pathname, { path: LinkTo.residents, exact: true }) || 
    !!matchPath(pathname, { path: LinkTo.specialProjects, exact: true }) || 
    !!matchPath(pathname, { path: LinkTo.partners, exact: true });
  

  if (AppTester.isFr() || AppTester.isOnlinesDesign()) {
    if (lang === 'fr') {
      return descriptions.intuitFr;
    }
    return descriptions.intuitEng;
  }

  if (isAKI) {
    if (isAwardsPage) {
      return descriptions.AKIAwards
    }
    if (isTagsPage) {
      return descriptions.AKITags
    }
    if (isThemesPage) {
      return descriptions.AKIThemes
    }
    if (isEduPage) {
      return descriptions.AKIEducation
    }
    if (isAbout) {
      return descriptions.AKIAbout
    }
    if (isSupport) {
      return descriptions.AKISupport
    }
    return descriptions.AKIMain
  }

  if (AppTester.isLectureMediiia() && isMediiiaResidentsPage) {
    return descriptions.mediiiaResidents.education
  }

  if (AppTester.isPortfolioArtz()) {
    return EMPTY_META;
  }

  if (AppTester.isUz()) {
    return EMPTY_META;
  }

  if (AppTester.isJhonataNet()) {
    return descriptions.jhonata
  }

  if (AppTester.isHseAnimation()) {
    return descriptions.hseAnimation
  }
  if (AppTester.isGalllleryArt()) {
    return descriptions.galllleryArt;
  }
  if (AppTester.isBooksGallllery()) {
    return descriptions.galllleryCom;
  }
  if (AppTester.isAcademy()) {
    return descriptions.creativeCity;
  }
  if (AppTester.isCGRAVE()) {
    return descriptions.cgraveRu;
  }
  if (AppTester.isGameDeziiign()) {
    return descriptions.gameDeziiignRu;
  }
  if (AppTester.isFashionDeziiign()) {
    return descriptions.fashionDeziiignRu;
  }
  if (AppTester.isBooksDeziiign()) {
    return descriptions.booksDeziiignRu;
  }
  if (AppTester.isPortfolio365()) {
    return descriptions.portfolio365;
  }
  if (AppTester.isDvaDesign()) {
    return descriptions.dvaDesign;
  }
  if (AppTester.isGreenAward()) {
    return descriptions.greenAwardRu;
  }
  if (AppTester.isMediiia()) {
    if (isMediiiaResidentsPage) {
      if (AppTester.isMediiiaMain()) {
        return descriptions.mediiiaResidents.main
      }
      if (AppTester.isMediiiaStories()) {
        return descriptions.mediiiaResidents.stories
      }
      if (AppTester.isMediiiaNature()) {
        return descriptions.mediiiaResidents.astro
      }
      if (AppTester.isMediiiaSport()) {
        return descriptions.mediiiaResidents.sport
      }
      if (AppTester.isMediiiaProf()) {
        return descriptions.mediiiaResidents.work
      }
      if (AppTester.isMediiiaCine()) {
        return descriptions.mediiiaResidents.cine
      }
      if (AppTester.isMediiiaAi()) {
        return descriptions.mediiiaResidents.ai
      }
      if (AppTester.isMediiiaArt()) {
        return descriptions.mediiiaResidents.art
      }
      if (AppTester.isMediiiaKiiids()) {
        return descriptions.mediiiaResidents.main
      }
      if (AppTester.isMediiiaFood()) {
        return descriptions.mediiiaResidents.food
      }
      if (AppTester.isMediiiaAuto()) {
        return descriptions.mediiiaResidents.auto
      }
      if (AppTester.isMediiiaConcept()) {
        return descriptions.mediiiaResidents.concept
      }
      if (AppTester.isHistoryMediiia()) {
        return descriptions.mediiiaResidents.history
      }
      if (AppTester.isMusicMediiia()) {
        return descriptions.mediiiaResidents.sound
      }
      if (AppTester.isMediiia365() || AppTester.isEventMediiia()) {
        return descriptions.mediiiaResidents.media365
      }
      if (AppTester.isMyMediiia()) {
        return descriptions.mediiiaResidents.my
      }
      if (AppTester.isMyMediiia()) {
        return descriptions.mediiiaResidents.my
      }
    }
    if (isPromptWeekend) {
      return descriptions.promptWeekend;
    }
    if (isPromptBrand) {
      return descriptions.promptBrand;
    }
    if (isPromptVideo) {
      return descriptions.promptVideo;
    }
    if (isPromptCode) {
      return descriptions.promptCode;
    }
    if (AppTester.isMediiiaFood()) {
      return descriptions.foodMediiia;
    }
    if (AppTester.isMediiiaCine()) {
      return descriptions.cineMediiia;
    }
    if (AppTester.isMediiiaAi()) {
      return descriptions.aiMediiia;
    }
    if (AppTester.isMusicMediiia()) {
      return descriptions.soundMediiia;
    }
    if (AppTester.isMediiiaArt()) {
      return descriptions.artMediiia;
    }
    if (AppTester.isMediiiaKiiids()) {
      return descriptions.kiiidsMediiia;
    }
    if (AppTester.isEventMediiia()) {
      return descriptions.mediiia365;
    }
    if (AppTester.isHistoryMediiia()) {
      return descriptions.historyMediiia;
    }
    if (AppTester.isMediiiaAuto()) {
      return descriptions.autoMediiia;
    }
    return descriptions.mediiiiaRu;
  }
  if (AppTester.isMediiiaUrban()) {
    return descriptions.urbanDeziiignRu;
  }
  if (AppTester.isAgeytomesh()) {
    return descriptions.ageytomeshCom;
  }
  if (AppTester.isContinuumSite()) {
    return descriptions.continuumSite;
  }
  if (AppTester.isGeoDafes()) {
    return descriptions.dafesNet;
  }
  if (AppTester.isStartHSE()) {
    return descriptions.startHse;
  }
  if (AppTester.isKiiidsArt()) {
    return descriptions.kiiidsArt;
  }
  if (AppTester.isBrnd()) {
    return descriptions.brnd;
  }
  if (AppTester.isDaMuseum()) {
    return descriptions.daMuseum;
  }
  if (AppTester.isGeograffee()) {
    return descriptions.geograffee;
  }
  if (AppTester.isSuperPuper()) {
    return descriptions.superPuper;
  }
  if (AppTester.isOnlines()) {
    return descriptions.onlines;
  }
  if (AppTester.isSchool()) {
    return descriptions.school;
  }
  if (AppTester.isAdcrDafesNet()) {
    return descriptions.adcr;
  }
  if (AppTester.isCreativeHSE()) {
    return descriptions.creativeHse;
  }
  if (AppTester.isLPUDesign()) {
    return descriptions.lpuDesign;
  }
  if (AppTester.isLMSHSE()) {
    return descriptions.lmsHsedesignRu;
  }
  if (AppTester.isHSEBiotech()) {
    return descriptions.hseBiotech;
  }
  if (AppTester.isHseSpace()) {
    return descriptions.hseSpace;
  }
  if (AppTester.isHSEDesign()) {
    if (isLab) {
      return descriptions.hsedesignRuLabs;
    }
    return isAwardsPage ? descriptions.hsedesignRuAwards : descriptions.hsedesignRu;
  }
  if (AppTester.isMonaLisaTravels()) {
    return descriptions.monalisatravels;
  }
  if (AppTester.isCompetition() || (AppTester.isDeziiign() && isAwardsPage)) {
    return descriptions.deziiignComAwards;
  }
  if (AppTester.isDeziiign()) {
    return descriptions.deziiignCom;
  }
  return EMPTY_META;
}

const useMetaDescription = () => {
  const isProjectPage = !!useRouteMatch('/project');
  const isDesignerPage = !!useRouteMatch('/designer');
  const isTeamPage = !!useRouteMatch('/teams/:id') && !AppTester.isLMSHSE();
  const isTagPage = !!useRouteMatch(LinkTo.tag);
  const isAwardsPage = !!useRouteMatch('/awards');
  const isCompetitionPage = !!useRouteMatch('/competition/:id');
  const isLab = !!useRouteMatch('/laboratories');
  const { pathname } = useLocation();
  const { i18n: { language } } = useTranslation();

  const meta = useMemo(() => {

    return getMetaDescription({ AppTester, pathname, lang: language });
  }, [isAwardsPage, isLab, language]);

  if (!meta) {
    return null;
  }

  const shouldDisplayMeta = !isProjectPage && !isDesignerPage && !isTeamPage && !isTagPage;
  const domain = window.location.origin;
  const currentUrl = window.location.href;

  const onlyDescription = isCompetitionPage;

  const descriptionTags = !!meta.description?.length ? [
    <meta name="description" content={meta.description} />,
    <meta property="og:description" content={meta.description} />,
    <meta name="twitter:description" content={meta.description} />,
  ] : [];

  if (onlyDescription) {
    return descriptionTags;
  }

  return shouldDisplayMeta && [
    <title>{meta.title}</title>,
    <meta name="title" content={meta.title} />,
    <meta property="og:site_name" content={domain} />,
    <meta property="og:url" content={currentUrl} />,
    <meta property="og:type" content="website" />,
    <meta property="og:title" content={meta.title} />,
    <meta property="twitter:domain" content={domain} />,
    <meta property="twitter:url" content={currentUrl} />,
    <meta name="twitter:title" content={meta.title} />,
    ...descriptionTags,
  ];
};

export default useMetaDescription;
import { useMemo } from 'react';
import { matchPath, useLocation, useRouteMatch } from 'react-router-dom';
import descriptions from './descriptions.json';
import { AppTester, AppTesterType } from 'supporting';
import { useTranslation } from 'react-i18next';
import { LinkTo } from 'shared/constants/linkTo';

interface TitleDescription {
  title: string;
  description: string;
}

const EMPTY_META: TitleDescription = { title: '', description: '' };

export const getMetaDescription = ({ AppTester, pathname, lang = 'ru' }: { AppTester: AppTesterType, pathname: string, lang?: string }) => {
  const isAwardsPage = !!matchPath(pathname, { path: '/awards', exact: true });
  const isLab = !!matchPath(pathname, { path: '/laboratories', exact: true });
  const isPromptWeekend = !!matchPath(pathname, { path: '/prompt-weekend', exact: true });
  const isPromptBrand = !!matchPath(pathname, { path: '/prompt-brand', exact: false });
  const isPromptVideo = !!matchPath(pathname, { path: '/prompt-video', exact: false });
  const isPromptCode = !!matchPath(pathname, { path: '/prompt-code', exact: false });

  const isAKI = AppTester.isAKI()
  const isTagsPage = !!matchPath(pathname, { path: '/tags', exact: true });
  const isThemesPage = !!matchPath(pathname, { path: '/competencies', exact: true });
  const isEduPage = !!matchPath(pathname, { path: '/education', exact: true });
  const isAbout = !!matchPath(pathname, { path: '/about', exact: true });
  const isSupport = !!matchPath(pathname, { path: '/support', exact: true });
  const isMediiiaResidentsPage = 
    !!matchPath(pathname, { path: LinkTo.residents, exact: true }) || 
    !!matchPath(pathname, { path: LinkTo.specialProjects, exact: true }) || 
    !!matchPath(pathname, { path: LinkTo.partners, exact: true });
  

  if (AppTester.isFr() || AppTester.isOnlinesDesign()) {
    if (lang === 'fr') {
      return descriptions.intuitFr;
    }
    return descriptions.intuitEng;
  }

  if (isAKI) {
    if (isAwardsPage) {
      return descriptions.AKIAwards
    }
    if (isTagsPage) {
      return descriptions.AKITags
    }
    if (isThemesPage) {
      return descriptions.AKIThemes
    }
    if (isEduPage) {
      return descriptions.AKIEducation
    }
    if (isAbout) {
      return descriptions.AKIAbout
    }
    if (isSupport) {
      return descriptions.AKISupport
    }
    return descriptions.AKIMain
  }

  if (AppTester.isLectureMediiia() && isMediiiaResidentsPage) {
    return descriptions.mediiiaResidents.education
  }

  if (AppTester.isPortfolioArtz()) {
    return EMPTY_META;
  }

  if (AppTester.isUz()) {
    return EMPTY_META;
  }

  if (AppTester.isJhonataNet()) {
    return descriptions.jhonata
  }

  if (AppTester.isHseAnimation()) {
    return descriptions.hseAnimation
  }
  if (AppTester.isGalllleryArt()) {
    return descriptions.galllleryArt;
  }
  if (AppTester.isBooksGallllery()) {
    return descriptions.galllleryCom;
  }
  if (AppTester.isAcademy()) {
    return descriptions.creativeCity;
  }
  if (AppTester.isCGRAVE()) {
    return descriptions.cgraveRu;
  }
  if (AppTester.isGameDeziiign()) {
    return descriptions.gameDeziiignRu;
  }
  if (AppTester.isFashionDeziiign()) {
    return descriptions.fashionDeziiignRu;
  }
  if (AppTester.isBooksDeziiign()) {
    return descriptions.booksDeziiignRu;
  }
  if (AppTester.isPortfolio365()) {
    return descriptions.portfolio365;
  }
  if (AppTester.isDvaDesign()) {
    return descriptions.dvaDesign;
  }
  if (AppTester.isGreenAward()) {
    return descriptions.greenAwardRu;
  }
  if (AppTester.isMediiia()) {
    if (isMediiiaResidentsPage) {
      if (AppTester.isMediiiaMain()) {
        return descriptions.mediiiaResidents.main
      }
      if (AppTester.isMediiiaStories()) {
        return descriptions.mediiiaResidents.stories
      }
      if (AppTester.isMediiiaNature()) {
        return descriptions.mediiiaResidents.astro
      }
      if (AppTester.isMediiiaSport()) {
        return descriptions.mediiiaResidents.sport
      }
      if (AppTester.isMediiiaProf()) {
        return descriptions.mediiiaResidents.work
      }
      if (AppTester.isMediiiaCine()) {
        return descriptions.mediiiaResidents.cine
      }
      if (AppTester.isMediiiaAi()) {
        return descriptions.mediiiaResidents.ai
      }
      if (AppTester.isMediiiaArt()) {
        return descriptions.mediiiaResidents.art
      }
      if (AppTester.isMediiiaKiiids()) {
        return descriptions.mediiiaResidents.main
      }
      if (AppTester.isMediiiaFood()) {
        return descriptions.mediiiaResidents.food
      }
      if (AppTester.isMediiiaAuto()) {
        return descriptions.mediiiaResidents.auto
      }
      if (AppTester.isMediiiaConcept()) {
        return descriptions.mediiiaResidents.concept
      }
      if (AppTester.isHistoryMediiia()) {
        return descriptions.mediiiaResidents.history
      }
      if (AppTester.isMusicMediiia()) {
        return descriptions.mediiiaResidents.sound
      }
      if (AppTester.isMediiia365() || AppTester.isEventMediiia()) {
        return descriptions.mediiiaResidents.media365
      }
      if (AppTester.isMyMediiia()) {
        return descriptions.mediiiaResidents.my
      }
      if (AppTester.isMyMediiia()) {
        return descriptions.mediiiaResidents.my
      }
    }
    if (isPromptWeekend) {
      return descriptions.promptWeekend;
    }
    if (isPromptBrand) {
      return descriptions.promptBrand;
    }
    if (isPromptVideo) {
      return descriptions.promptVideo;
    }
    if (isPromptCode) {
      return descriptions.promptCode;
    }
    if (AppTester.isMediiiaFood()) {
      return descriptions.foodMediiia;
    }
    if (AppTester.isMediiiaCine()) {
      return descriptions.cineMediiia;
    }
    if (AppTester.isMediiiaAi()) {
      return descriptions.aiMediiia;
    }
    if (AppTester.isMusicMediiia()) {
      return descriptions.soundMediiia;
    }
    if (AppTester.isMediiiaArt()) {
      return descriptions.artMediiia;
    }
    if (AppTester.isMediiiaKiiids()) {
      return descriptions.kiiidsMediiia;
    }
    if (AppTester.isEventMediiia()) {
      return descriptions.mediiia365;
    }
    if (AppTester.isHistoryMediiia()) {
      return descriptions.historyMediiia;
    }
    if (AppTester.isMediiiaAuto()) {
      return descriptions.autoMediiia;
    }
    return descriptions.mediiiiaRu;
  }
  if (AppTester.isMediiiaUrban()) {
    return descriptions.urbanDeziiignRu;
  }
  if (AppTester.isAgeytomesh()) {
    return descriptions.ageytomeshCom;
  }
  if (AppTester.isContinuumSite()) {
    return descriptions.continuumSite;
  }
  if (AppTester.isGeoDafes()) {
    return descriptions.dafesNet;
  }
  if (AppTester.isStartHSE()) {
    return descriptions.startHse;
  }
  if (AppTester.isKiiidsArt()) {
    return descriptions.kiiidsArt;
  }
  if (AppTester.isBrnd()) {
    return descriptions.brnd;
  }
  if (AppTester.isDaMuseum()) {
    return descriptions.daMuseum;
  }
  if (AppTester.isGeograffee()) {
    return descriptions.geograffee;
  }
  if (AppTester.isSuperPuper()) {
    return descriptions.superPuper;
  }
  if (AppTester.isOnlines()) {
    return descriptions.onlines;
  }
  if (AppTester.isSchool()) {
    return descriptions.school;
  }
  if (AppTester.isAdcrDafesNet()) {
    return descriptions.adcr;
  }
  if (AppTester.isCreativeHSE()) {
    return descriptions.creativeHse;
  }
  if (AppTester.isLPUDesign()) {
    return descriptions.lpuDesign;
  }
  if (AppTester.isLMSHSE()) {
    return descriptions.lmsHsedesignRu;
  }
  if (AppTester.isHSEBiotech()) {
    return descriptions.hseBiotech;
  }
  if (AppTester.isHseSpace()) {
    return descriptions.hseSpace;
  }
  if (AppTester.isHSEDesign()) {
    if (isLab) {
      return descriptions.hsedesignRuLabs;
    }
    return isAwardsPage ? descriptions.hsedesignRuAwards : descriptions.hsedesignRu;
  }
  if (AppTester.isMonaLisaTravels()) {
    return descriptions.monalisatravels;
  }
  if (AppTester.isCompetition() || (AppTester.isDeziiign() && isAwardsPage)) {
    return descriptions.deziiignComAwards;
  }
  if (AppTester.isDeziiign()) {
    return descriptions.deziiignCom;
  }
  return EMPTY_META;
}

const useMetaDescription = () => {
  const isProjectPage = !!useRouteMatch('/project');
  const isDesignerPage = !!useRouteMatch('/designer');
  const isTeamPage = !!useRouteMatch('/teams/:id') && !AppTester.isLMSHSE();
  const isTagPage = !!useRouteMatch(LinkTo.tag);
  const isAwardsPage = !!useRouteMatch('/awards');
  const isCompetitionPage = !!useRouteMatch('/competition/:id');
  const isLab = !!useRouteMatch('/laboratories');
  const { pathname } = useLocation();
  const { i18n: { language } } = useTranslation();

  const meta = useMemo(() => {

    return getMetaDescription({ AppTester, pathname, lang: language });
  }, [isAwardsPage, isLab, language]);

  if (!meta) {
    return null;
  }

  const shouldDisplayMeta = !isProjectPage && !isDesignerPage && !isTeamPage && !isTagPage;
  const domain = window.location.origin;
  const currentUrl = window.location.href;

  const onlyDescription = isCompetitionPage;

  const descriptionTags = !!meta.description?.length ? [
    <meta name="description" content={meta.description} />,
    <meta property="og:description" content={meta.description} />,
    <meta name="twitter:description" content={meta.description} />,
  ] : [];

  if (onlyDescription) {
    return descriptionTags;
  }

  return shouldDisplayMeta && [
    <title>{meta.title}</title>,
    <meta name="title" content={meta.title} />,
    <meta property="og:site_name" content={domain} />,
    <meta property="og:url" content={currentUrl} />,
    <meta property="og:type" content="website" />,
    <meta property="og:title" content={meta.title} />,
    <meta property="twitter:domain" content={domain} />,
    <meta property="twitter:url" content={currentUrl} />,
    <meta name="twitter:title" content={meta.title} />,
    ...descriptionTags,
  ];
};

export default useMetaDescription;
